import React from 'react';

export const WORKFLOW_9_STEPS = [
  { step: 1, key: 'lead', label: '1. Lead', icon: '🎯', color: '#6366f1', bg: 'rgba(99,102,241,0.15)', desc: 'Inquiry' },
  { step: 2, key: 'quotation', label: '2. Quotation', icon: '📜', color: '#3b82f6', bg: 'rgba(59,130,246,0.15)', desc: 'Specs & Quote' },
  { step: 3, key: 'customer_po', label: '3. PO', icon: '📑', color: '#8b5cf6', bg: 'rgba(139,92,246,0.15)', desc: 'Customer PO' },
  { step: 4, key: 'pi', label: '4. PI', icon: '🧾', color: '#d97706', bg: 'rgba(217,119,6,0.15)', desc: 'Proforma Inv' },
  { step: 5, key: 'invoice', label: '5. Invoice', icon: '🏷️', color: '#0ea5e9', bg: 'rgba(14,165,233,0.15)', desc: 'Tax Bill / DC' },
  { step: 6, key: 'payment', label: '6. Payment', icon: '💳', color: '#10b981', bg: 'rgba(16,185,129,0.15)', desc: 'Pay / Credit' },
  { step: 7, key: 'assemble', label: '7. Assembly', icon: '🔧', color: '#f59e0b', bg: 'rgba(245,158,11,0.15)', desc: '(Store) Assembly' },
  { step: 8, key: 'packing', label: '8. Packing', icon: '📦', color: '#6366f1', bg: 'rgba(99,102,241,0.15)', desc: 'Carton Packing' },
  { step: 9, key: 'dispatched', label: '9. Dispatch', icon: '🚚', color: '#22c55e', bg: 'rgba(34,197,94,0.15)', desc: 'LR & Outward' }
];

export function determineOrderStep(record) {
  if (!record) return 1;

  // Check if dispatch record
  if (record.status === 'dispatched' || record.dispatchedAt) return 9;
  if (record.status === 'packing' || record.packedAt) return 8;
  if (record.status === 'assemble' || record.assembledAt) return 7;

  // Check sales record / pipeline
  if (record.stage === 'sales_order') {
    if (record.dispatchId?.status === 'dispatched') return 9;
    if (record.dispatchId?.status === 'packing') return 8;
    if (record.dispatchId?.status === 'assemble') return 7;
    if (record.paymentStatus === 'paid' || record.paymentStatus === 'partial' || record.approvalStatus === 'approved') return 6;
    return 5;
  }
  if (record.stage === 'customer_po') return 3;
  if (record.stage === 'pi') return 4;
  if (record.stage === 'quotation') return 2;
  return 1;
}

export default function OrderWorkflowBanner({ activeStep = 1, currentStageKey = '', onStepClick }) {
  let currentNum = activeStep;
  if (currentStageKey) {
    const found = WORKFLOW_9_STEPS.find(s => s.key === currentStageKey);
    if (found) currentNum = found.step;
  }

  return (
    <div style={{
      marginBottom: '20px',
      padding: '14px 16px',
      background: 'rgba(255,255,255,0.02)',
      borderRadius: '14px',
      border: '1px solid var(--border)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '10px',
        borderBottom: '1px solid rgba(255,255,255,0.05)',
        paddingBottom: '8px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '0.95rem', fontWeight: 800, color: 'var(--text-primary)', letterSpacing: '0.3px' }}>
            🔄 End-to-End 9-Step Lifecycle:
          </span>
          <span style={{ fontSize: '0.78rem', color: 'var(--text-dim)' }}>
            Lead ➔ Quotation ➔ PO ➔ PI ➔ Invoice ➔ Payment ➔ Assembly ➔ Packing ➔ Dispatch
          </span>
        </div>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(105px, 1fr))',
        gap: '8px'
      }}>
        {WORKFLOW_9_STEPS.map((s) => {
          const isActive = currentNum === s.step;
          const isCompleted = currentNum > s.step;

          return (
            <div
              key={s.step}
              onClick={() => onStepClick && onStepClick(s)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 10px',
                borderRadius: '10px',
                background: isActive ? s.bg : isCompleted ? 'rgba(34,197,94,0.06)' : 'rgba(255,255,255,0.01)',
                border: `1px solid ${isActive ? s.color : isCompleted ? 'rgba(34,197,94,0.3)' : 'rgba(255,255,255,0.05)'}`,
                cursor: onStepClick ? 'pointer' : 'default',
                transition: 'all 0.15s ease'
              }}
            >
              <div style={{
                width: '26px',
                height: '26px',
                borderRadius: '50%',
                background: isActive ? s.color : isCompleted ? '#10b981' : 'rgba(255,255,255,0.06)',
                color: isActive || isCompleted ? '#fff' : 'var(--text-dim)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.78rem',
                fontWeight: 800,
                flexShrink: 0
              }}>
                {isCompleted ? '✓' : s.step}
              </div>

              <div style={{ overflow: 'hidden' }}>
                <div style={{
                  fontWeight: 700,
                  fontSize: '0.78rem',
                  color: isActive ? s.color : isCompleted ? '#10b981' : 'var(--text-primary)',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden'
                }}>
                  {s.icon} {s.label.split('. ')[1]}
                </div>
                <div style={{
                  fontSize: '0.66rem',
                  color: 'var(--text-dim)',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden'
                }}>
                  {s.desc}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function OrderStepBadge({ record }) {
  const stepNum = determineOrderStep(record);
  const stepConfig = WORKFLOW_9_STEPS.find(s => s.step === stepNum) || WORKFLOW_9_STEPS[0];

  return (
    <span style={{
      background: stepConfig.bg,
      color: stepConfig.color,
      border: `1px solid ${stepConfig.color}`,
      borderRadius: '8px',
      padding: '3px 8px',
      fontSize: '0.75rem',
      fontWeight: 700,
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      whiteSpace: 'nowrap'
    }}>
      <span>{stepConfig.icon}</span>
      <span>Step {stepConfig.step}/9: {stepConfig.label.split('. ')[1]}</span>
    </span>
  );
}
